import styled from "styled-components";
import { uid } from "../utils";
import { BodyText } from "./Text";
import { mediaQueries } from "../common/constants";

const Footer = () => {
	const logos = [
		"/img/ambt-logo-e1689872214369.jpg",
		"/img/ukcp-logo.jpg",
		"/img/eabp-logo-e1689872142131.png"
	];
	return (
		<>
			<LogosContainer>
				{logos.map((logo) => {
					return <Logo key={uid()} src={logo} />;
				})}
			</LogosContainer>
			<CopyrightText>
				© all rights reserved to the London School of Biodynamic
				Psychotherapy, 2025
			</CopyrightText>
		</>
	);
};

export default Footer;

const LogosContainer = styled.div`
	width: 80%;
	display: flex;
	margin: 50px auto 0;
	justify-content: space-around;
	flex-wrap: wrap;

	${mediaQueries.smallScreensAndSmaller} {
		flex-direction: column;
	}
`;

const Logo = styled.img`
	width: 250px;
	height: 150px;
	max-width: 90%;
	object-fit: contain;

	${mediaQueries.mediumScreensAndSmaller} {
		width: 150px;
		height: fit-content;
		margin: 5px auto;
	}
`;

const CopyrightText = styled(BodyText)`
	text-align: center;
	margin: 20px;
`;
